module.exports = __webpack_public_path__ + "static/media/feat_tcr.15e7795d.png";